import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { getCurrentUserPermissions } from '../../features/user/redux/userSelectors';
import { RootState } from '../../store';
import { ResourceType } from '../PricePrgClient';

const mapStateToProps = (state: RootState) => ({
    userPermissions: getCurrentUserPermissions(state)
});

type OwnProps = RouteProps & {
    resource: ResourceType;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const GuardedRoute = ({ userPermissions, resource, component: Component, ...rest }: Props) => (
    <Route
        {...rest}
        render={props => {
            if (!userPermissions.isInitialized) {
                return null;
            }

            return (userPermissions.isAdmin || userPermissions.accessiblePages.includes(resource)) &&
                Component != null ? (
                <Component {...props} />
            ) : (
                <Redirect to="/" />
            );
        }}
    />
);

export default connect(mapStateToProps)(GuardedRoute);
